export default "__VITE_ASSET__b4d54896__"